import RequestStatus from 'src/model/RequestStatus';
import { ProductInfo, SelectedProductResponse } from 'src/model/ProductMatch';
import { AdditionalInfoResponse } from 'src/model/AdditionalInfo';

export const SELECTED_PRODUCT_QUERY_START = 'SELECTED_PRODUCT_QUERY_START';
export const SELECTED_PRODUCT_QUERY_UPDATING =
  'SELECTED_PRODUCT_QUERY_UPDATING';
export const SELECTED_PRODUCT_QUERY_SUCCESS = 'SELECTED_PRODUCT_QUERY_SUCCESS';
export const SELECTED_PRODUCT_QUERY_FAILED = 'SELECTED_PRODUCT_QUERY_FAILED';
export const SELECTED_PRODUCT_REMOVE = 'SELECTED_PRODUCT_REMOVE';
export const ADDITIONAL_INFO_QUERY_SUCCESS = 'ADDITIONAL_INFO_QUERY_SUCCESS';
export const SWITCH_AMAZON_STORE_START = 'SWITCH_AMAZON_STORE_START';
export const SWITCH_AMAZON_STORE_START_NEW = 'SWITCH_AMAZON_STORE_START_NEW';

export interface SelectedProductQueryStartAction {
  readonly type: string;
  readonly requestStatus: RequestStatus;
  readonly countryCode: string;
  readonly selectedProduct: ProductInfo;
  readonly itemPriceFromUrl?: number;
  readonly shippingCostFromUrl?: number;
}

export const setSelectedProductQueryStart = (
  countryCode: string,
  selectedProduct: ProductInfo,
  itemPriceFromUrl?: number,
  shippingCostFromUrl?: number,
): SelectedProductQueryStartAction => ({
  type: SELECTED_PRODUCT_QUERY_START,
  requestStatus: RequestStatus.LOADING,
  countryCode,
  selectedProduct,
  itemPriceFromUrl,
  shippingCostFromUrl,
});

export interface GetSelectedProductQueryComplete {
  readonly type: string;
  readonly requestStatus: RequestStatus;
  readonly selectedProductData: any;
}

export const getSelectedProductQueryUpdatingAction = (
  response: SelectedProductResponse,
): GetSelectedProductQueryComplete => ({
  type: SELECTED_PRODUCT_QUERY_UPDATING,
  requestStatus: RequestStatus.UPDATING,
  selectedProductData: response,
});

export const getSelectedProductQuerySuccessAction = (
  response: SelectedProductResponse,
): GetSelectedProductQueryComplete => ({
  type: SELECTED_PRODUCT_QUERY_SUCCESS,
  requestStatus: RequestStatus.SUCCESS,
  selectedProductData: response,
});

export const getAdditionalInfoQuerySuccessAction = (
  response: AdditionalInfoResponse,
): GetSelectedProductQueryComplete => ({
  type: ADDITIONAL_INFO_QUERY_SUCCESS,
  requestStatus: RequestStatus.SUCCESS,
  selectedProductData: response,
});

export const getSelectedProductQueryFailedAction =
  (): GetSelectedProductQueryComplete => ({
    type: SELECTED_PRODUCT_QUERY_FAILED,
    requestStatus: RequestStatus.ERROR,
    selectedProductData: null,
  });

export interface SwitchStoreStartAction {
  readonly type: string;
  readonly requestStatus: RequestStatus;
  readonly countryCode: string;
  readonly searchKey: string;
  readonly product: ProductInfo;
  readonly itemPriceFromUrl?: number;
  readonly shippingCostFromUrl?: number;
}

export const setSwitchStoreStart = (
  countryCode: string,
  product: ProductInfo,
  itemPriceFromUrl?: number,
  shippingCostFromUrl?: number,
): SwitchStoreStartAction => ({
  type: SWITCH_AMAZON_STORE_START,
  requestStatus: RequestStatus.LOADING,
  countryCode,
  searchKey: product.asin,
  product,
  itemPriceFromUrl,
  shippingCostFromUrl,
});

export const setSwitchStoreNewStart = (
  countryCode: string,
  product: ProductInfo,
): SwitchStoreStartAction => ({
  type: SWITCH_AMAZON_STORE_START_NEW,
  requestStatus: RequestStatus.LOADING,
  countryCode,
  searchKey: product.asin,
  product,
});

export interface RemoveSelectedProductAction {
  readonly type: string;
}

export const removeSelectedProduct = (): RemoveSelectedProductAction => ({
  type: SELECTED_PRODUCT_REMOVE,
});
